import React from 'react';
import { CTAButton } from './CTAButton';
export const ComparisonSection = () => {
  return <section id="faq" className="w-full bg-white py-12 px-4" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-teal-700 mb-8" data-id="element-69">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4 mb-8" data-id="element-70">
          <div className="bg-gray-50 p-5 rounded-lg" data-id="element-71">
            <h3 className="font-semibold text-lg mb-2 text-teal-700" data-id="element-72">
              Will it roll down?
            </h3>
            <p className="text-gray-600" data-id="element-73">
              The breathable knit, tapered cuff, and discreet micro‑grip are
              designed for fewer readjustments during daily wear. If it rolls or
              bunches on you, you're covered by our 60‑day guarantee.
            </p>
          </div>
          <div className="bg-gray-50 p-5 rounded-lg" data-id="element-74">
            <h3 className="font-semibold text-lg mb-2 text-teal-700" data-id="element-75">
              What's it made of?
            </h3>
            <p className="text-gray-600" data-id="element-76">
              High‑bamboo‑content blend with organic cotton and elastic for
              gentle stretch.
            </p>
          </div>
          <div className="bg-gray-50 p-5 rounded-lg" data-id="element-77">
            <h3 className="font-semibold text-lg mb-2 text-teal-700" data-id="element-78">
              Can I wear it under clothes?
            </h3>
            <p className="text-gray-600" data-id="element-79">
              Yes—low‑profile design fits under leggings, jeans, or scrubs.
            </p>
          </div>
          <div className="bg-gray-50 p-5 rounded-lg" data-id="element-80">
            <h3 className="font-semibold text-lg mb-2 text-teal-700" data-id="element-81">
              Is it for workouts or long shifts?
            </h3>
            <p className="text-gray-600" data-id="element-82">
              Great for everyday support, walks, light workouts, yoga, and long
              on‑your‑feet days. (It's not a rigid brace; if you have an acute
              injury or post‑surgical needs, consult your provider.)
            </p>
          </div>
          <div className="bg-gray-50 p-5 rounded-lg" data-id="element-83">
            <h3 className="font-semibold text-lg mb-2 text-teal-700" data-id="element-84">
              How do I wash it?
            </h3>
            <p className="text-gray-600" data-id="element-85">
              Machine wash cold, gentle cycle. Air dry. Avoid high heat to
              preserve the knit and gentle compression.
            </p>
          </div>
          <div className="bg-gray-50 p-5 rounded-lg" data-id="element-86">
            <h3 className="font-semibold text-lg mb-2 text-teal-700" data-id="element-87">
              When will my order ship?
            </h3>
            <p className="text-gray-600" data-id="element-88">
              This week's batch ships Friday. After that, most orders ship
              within 1–2 business days. Popular sizes may restock in 2–3 weeks.
            </p>
          </div>
          <div className="bg-gray-50 p-5 rounded-lg" data-id="element-89">
            <h3 className="font-semibold text-lg mb-2 text-teal-700" data-id="element-90">
              What's the return policy?
            </h3>
            <p className="text-gray-600" data-id="element-91">
              60‑day "Love it or return it." First size exchange is free.
            </p>
          </div>
        </div>
        <CTAButton data-id="element-92" />
      </div>
    </section>;
};